import FloatingCards from "./FloatingCards/FloatingCards";

export class FloatingStamps {
  constructor(container) {
    this.el = container.querySelector('#floating-stamps');
    if (this.el) {
      this.init();
    }
  }

  init() {
    this.floatingCards = new FloatingCards({container: this.el});
  }

  dispose() {
    if (this.floatingCards) {
      this.floatingCards.dispose();
      this.floatingCards = null;
      this.el = null;
    }
  }
}
